import { BREAKPOINT_BP_600, BREAKPOINT_BP_750, BREAKPOINT_BP_900, BREAKPOINT_BP_1160, BREAKPOINTS } from '../constants';

export const getSlidesCountForWidth = (width: number): number => {
    if (width <= BREAKPOINT_BP_600) {
        return BREAKPOINTS[BREAKPOINT_BP_600];
    }

    if (width <= BREAKPOINT_BP_750) {
        return BREAKPOINTS[BREAKPOINT_BP_750];
    }

    if (width <= BREAKPOINT_BP_900) {
        return BREAKPOINTS[BREAKPOINT_BP_900];
    }

    return BREAKPOINTS[BREAKPOINT_BP_1160];
};
